exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".option-container[data-v-5de2059a]{display:flex;flex-flow:column;row-gap:10px}.selected[data-v-5de2059a]{background-color:#007bff;border-color:#007bff;color:#ffffff}.summary[data-v-5de2059a]{font-weight:bold;margin-top:20px}[data-v-5de2059a] .time-input{max-width:12rem}\n", ""]);

